<template lang="pug">
  b-modal#transferCash(
    ref="transferCash"
    :title="$t('ui.transfer')"
    centered
    no-fade
    no-close-on-backdrop
    :busy="loading"
    size="sm"
    @ok="done"
    @show="reset"
    @shown="shown"
  )
    b-form(novalidate :disabled="!submission.success" @submit.stop.prevent="submit")
      .form-group
        label {{ $t("ui.account_id") }}
        DebounceInput(
          type="text"
          ref="account_id"
          :placeholder='$t("ui.account_id")'
          :value="accountID.toUpperCase()"
          readonly
        )
      .form-group
        label {{ $t("ui.current_balance") }}
        DebounceInput(
          type="text"
          ref="current_balance"
          :placeholder='$t("ui.current_balance")'
          :value="currentBalance | currency"
          readonly
        )
      .form-group
        label {{ $t('ui.transfer_method') }}
        b-form-select(
          size="sm"
          v-model="method"
          :options="options"
        )
      .form-group
        label {{ $t("ui.amount") }}
        DebounceInput(
          type="text"
          ref="settle_amount"
          :dirty="$v.settle_amount.$dirty"
          :error="$v.settle_amount.$error"
          :placeholder='$t("ui.amount")'
          v-model.trim.lazy="$v.settle_amount.$model"
        )
        ValidateResult(:value="$v.settle_amount" :name="$t('ui.settle_amount')")
        //- ValidateResult(:value="$v.settle_amount" :name="$t('ui.settle_amount')" :min="currentBalance*0" :max="currentBalance*-1")
      .form-group
        label {{ $t("ui.remark") }}
        DebounceInput(
          type="text"
          ref="remark"
          :dirty="$v.remark.$dirty"
          :error="$v.remark.$error"
          :placeholder='$t("ui.remark")'
          v-model.trim.lazy="$v.remark.$model"
          :maxLength="$v.remark.$params.maxLength.max"
          :disabled="loading"
        )
        ValidateResult(:value="$v.remark" :name="$t('ui.remark')")
      .form-group
        b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-times" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, minValue, maxLength, helpers } from "vuelidate/lib/validators";
import config from "@/config";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    accountID: {
      type: String,
      default: "",
    },
    currentBalance: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      method: "1",
      options: [{ value: "1", text: this.$t("ui.deposit") }, { value: "2", text: this.$t("ui.withdrawal") }],
      settle_amount: "0",
      remark: "",
      loading: false,
      submission: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
    accCashBalance() {
      return this.$store.getters.getAccountCashBalance
    }
  },
  validations: {
    settle_amount: {
      required(value) {
        return value != "0" && value
      },
      minValue(value) {
        let mode = this.method
        if(mode == "1") {
          let curr = this.$helpers.convertSettlementNumber(this.accCashBalance)
          if(curr > 0) {
            return minValue(curr * -1)(this.$helpers.convertSettlementNumber(value))
          } else {
            return minValue(0.01)(this.$helpers.convertSettlementNumber(value))
          }
        } else {
          let curr = this.$helpers.convertSettlementNumber(this.currentBalance)
          if(curr > 0) {
            return minValue(curr * -1)(this.$helpers.convertSettlementNumber(value))
          } else {
            return minValue(0.01)(this.$helpers.convertSettlementNumber(value))
          }
        }
      }
    },
    remark: {
      maxLength: maxLength(100)
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loading = true
        this.$swal({
          title: this.$t("ui.status"),
          text: this.$t("message.settlement_confirm"),
          type: "warning",
          showCancelButton: true,
          allowOutsideClick: false
        }).then(result => {
          if (result.value) {
            this.settlement()
          } else if (
            // Read more about handling dismissals
            result.dismiss === 'cancel'
          ) {
            this.loading = false
            this.$swal({
              title: this.$t("ui.cancel"),
              text: this.$t("message.settlement_cancel"),
              type: "error",
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel();
              }
            });
          }
        });
      }
    },
    settlement: function() {
      let url = (this.$store.getters.accountType == 2) ? config.transferCashMemberUrl() : config.transferCashAgentUrl()
      let account_id = this.accountID
      let settle_amount = this.settle_amount
      let method = this.method
      let remark = this.remark
      this.$store
        .dispatch("user/transferCash", { url, account_id, settle_amount, method, remark })
        .then(response => {
          this.loading = false
          this.submission.success = response.success
          this.submission.status = response.errorTag
          if(this.submission.success == true) {
            this.$swal({
              title: this.$t("ui.succeed"),
              text: this.$t("message.settlement_success"),
              type: "success",
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel();
              }
            });
          }
        })
        .catch(response => {
          console.log("Failed:settlementCash", response)
          this.loading = false
          this.submission.success = response.success
          this.submission.status = this.$t("message." + response.errorTag)
        });
    },
    reset: function() {
      this.submission.success = true
      this.submission.status = ""
      this.settle_amount = 0
      this.remark = ""
    },
    shown: function() {
      this.$nextTick(() => {
        this.$v.$reset()
      });
    },
    cancel: function() {
      this.$refs.transferCash.hide()
      this.$emit("clicked")
    }
  }
};
</script>

